module.exports = __webpack_public_path__ + "img/vertical_3_7_3.82e7c67a.png";